import { Tooltip } from "antd";
import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

export default function InvestmentChart(props) {
  const data = [
    {
      name: "Investment\n Amount",
      uv: props.summaryData.totalInvestmentValue,
      fill: "#499CE8",
    },
    {
      name: "Current Value",
      uv: props.summaryData.isMatured? props.summaryData.refundAmount
        : props.summaryData.totalSurrenderValue,
      fill: "#77D272",
    },
  ];

  return (
    <ResponsiveContainer width="94%" height={100}>
      <BarChart width={50} height={100} data={data}>
        {/* <Tooltip /> */}
        {/* <Tooltip /> */}
        {/* <CartesianGrid /> */}
        <XAxis
          dataKey="name"
          style={{ fontSize: "0.7rem" }}
          tick={{ width: 30, color: "black" }}
          //   stroke="#ff994b"
        />
        {/* <YAxis></YAxis> */}
        <Bar barSize={30} dataKey="uv" fill="fill" label="name" />
      </BarChart>
    </ResponsiveContainer>
  );
}
